var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90636 16.6375C5.74136 16.6375 5.57636 16.5825 5.41137 16.5C5.13637 16.335 4.99887 16.06 4.99887 15.7575V7.01248L0.18638 1.43C-0.00611978 1.155 -0.0611197 0.797498 0.0763799 0.494999C0.21388 0.192499 0.543879 0 0.901378 0H14.1013C14.4588 0 14.7888 0.219999 14.9263 0.549999C15.0638 0.879998 15.0088 1.21 14.7613 1.485L10.0314 6.98498V13.3925C10.0314 13.5575 9.97635 13.805 9.72885 14.0525L9.67385 14.1075L6.37386 16.555C6.23636 16.61 6.07136 16.6375 5.90636 16.6375ZM6.04386 6.29748C6.18136 6.46248 6.26386 6.70998 6.26386 6.87498V15.0975L8.82135 13.2V6.87498C8.82135 6.73748 8.82135 6.48998 9.04135 6.26998L13.3313 1.265H1.67138L6.04386 6.29748Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b21894fd6122d26484007953aea62bb4.svg";
export { ForwardRef as ReactComponent };